import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useProfileState from '@/state/profile/profileState';
import { ProfileStoreKey } from '@/models/Profile';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileAboutusView',
  setup(__props) {

const { profile } = useProfileState(ProfileStoreKey.PROFILE);

const company = computed(() => profile.value?.company);

return { __sfc: true,profile, company, BCXMarkdown }
}

})